
import Layout from "@/components/layout/Layout";
import { DashboardStats } from "@/components/dashboard/DashboardStats";
import { DashboardCollections } from "@/components/dashboard/DashboardCollections";
import { useCollectionManagement } from "@/hooks/useCollectionManagement";
import { useProductDescriptions } from "@/hooks/useProductDescriptions";
import { useAuth } from "@/components/auth/useAuth";
import { useState, useEffect } from "react";
import { CollectionManagement } from "@/components/collections/CollectionManagement";
import { LayoutDashboard } from "lucide-react";
import { useCollections } from "@/hooks/useCollections";
import { TestEmailButton } from "@/components/dashboard/TestEmailButton";
import { LandingPage } from "@/components/landing/LandingPage";

const Index = () => {
  console.log("Index component rendering"); // Debug log
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const {
    handleCollectionSelect,
    handleCollectionEdit,
    handleDelete
  } = useCollectionManagement();

  // Use more resilient query configuration
  const { user, loading: authLoading } = useAuth();
  const { descriptions, isLoading: descriptionsLoading } = useProductDescriptions();
  const { collections, isLoading: collectionsLoading } = useCollections();

  // Debug page rendering
  useEffect(() => {
    console.log("Index page rendered", {
      hasUser: !!user,
      hasDescriptions: !!descriptions,
      hasCollections: !!collections,
      authLoading,
      descriptionsLoading,
      collectionsLoading,
      currentPath: window.location.pathname
    });
  }, [user, descriptions, collections, authLoading, descriptionsLoading, collectionsLoading]);

  // Show landing page if no user is logged in and auth is not loading
  if (!user && !authLoading) {
    console.log("Rendering landing page for non-authenticated user");
    return <LandingPage />;
  }

  // Show loading state while auth is being checked
  if (authLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="text-center">
          <div className="animate-spin w-8 h-8 border-4 border-primary border-t-transparent rounded-full mx-auto mb-4"></div>
          <p className="text-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  // Find the first collection that has approved products
  const completedCollection = collections?.find(collection => {
    // Check if this collection has any approved product descriptions
    return collection.product_descriptions?.some((desc: any) => desc.status === 'approved') || false;
  });

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-6">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center space-x-2">
            <LayoutDashboard className="h-6 w-6" />
            <h1 className="text-3xl font-bold dark:text-white">Dashboard</h1>
          </div>
          
          {completedCollection && (
            <TestEmailButton 
              collectionId={completedCollection.id}
              disabled={!completedCollection}
            />
          )}
        </div>
        
        <DashboardStats descriptions={descriptions} />

        <DashboardCollections
          collections={collections}
          selectedCollection={undefined}
          setSelectedCollection={handleCollectionSelect}
          onCreateCollection={() => setIsCreateDialogOpen(true)}
          onEdit={handleCollectionEdit}
          onDelete={handleDelete}
        />

        <CollectionManagement
          open={isCreateDialogOpen}
          onOpenChange={setIsCreateDialogOpen}
        />
      </div>
    </Layout>
  );
};

export default Index;
